import React, { Component } from 'react';

import BaseRouteHandler from '../../common/routeHandlers/BaseRouteHandler';
import AddonDiscoveryRouteProcessor from './AddonDiscoveryRouteProcessor';

// exposed for testing
export const initialize = () => {
  return class AddonDiscoveryRouteHandler extends Component {
    render() {
      return (
        <BaseRouteHandler includeFooter includeSearch={false}>
          <AddonDiscoveryRouteProcessor {...this.props} />
        </BaseRouteHandler>
      );
    }
  };
};

export default initialize();
